<template lang="pug">
#solicitar-laudos
    header
        h1 {{ $t('laudos.solicitarLaudoBacenResolucaoCentoEQuarenta') }}

    .territorios
        header.mt-3.mb-3
            h2 {{ $t('laudos.territoriosAdicionados') }}
            BaseButton(
                type='primary',
                size='small',
                icon='el-icon-plus',
                @click='changeShowModalAddTerritorios'
            )
                | {{ $t('laudos.adicionarTerritorios') }}

        main(v-if='Object.keys(territorios).length > 0')
            CardDadosTerritorio.mb-2(
                v-for='(id, index) in Object.keys(territorios)',
                :territorio='territorios[id]',
                :index='index',
                :key='`${territorios[id].nome}_${id}`',
                :valido='cardValido[index]',
                @removerTerritorio='removerTerritorio',
                @getValidacao='setValidacao',
                @getDados='setDados'
            )

        main.sem-territorios(v-else)
            a(@click='changeShowModalAddTerritorios')
                | {{ $t('laudos.adicionarTerritorios') }}

    .acoes
        BaseButton(size='small', @click='$router.go(-1)')
            | {{ $t('mensagens.comuns.voltar') }}

        BaseButton(
            v-if='Object.keys(territorios).length > 0 && finalizar',
            size='small',
            type='primary',
            icon='el-icon-check',
            @click='solicitarLaudos'
        )
            | {{ $t('mensagens.comuns.finalizar') }}
        BaseButton(
            v-else-if='Object.keys(territorios).length > 0',
            size='small',
            type='primary',
            icon='el-icon-check',
            disabled
        )
            | {{ $t('mensagens.comuns.finalizar') }}

    el-dialog.add-territorio(
        :title='$t("laudos.selecioneUmOuMaisTerritoriosParaSolicitacaoDeLaudos")',
        :visible.sync='showModalAddTerritorios',
        close='changeShowModalAddTerritorios'
    )
        SelecionarTerritorio(
            :selecionados='territoriosSelecionados',
            @getTerritoriosSelecionados='addTerritorios'
        )
</template>

<script>
import CardDadosTerritorio from '@/modules/laudos/components/bacenResolucao140/CardDadosTerritorio';
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio';

import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/modules/laudos/services/LaudosService';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'PageSolicitarLaudoBenfeitorias',

    components: {
        CardDadosTerritorio,
        SelecionarTerritorio,
        BaseButton
    },

    data() {
        return {
            idsTerritoriosSelecionados: [],
            territoriosSelecionados: [],
            dados: {},
            territorios: {},
            cardValido: {},
            showModalAddTerritorios: false,
            finalizar: false
        };
    },

    mounted() {
        const idsTerritoriosSelecionadosString =
            this.$route.params.idsTerritorio.split('-');
        idsTerritoriosSelecionadosString.pop();

        idsTerritoriosSelecionadosString.forEach(id =>
            this.idsTerritoriosSelecionados.push(parseInt(id))
        );
        this.getTerritorios();
    },

    methods: {
        getTerritorios() {
            const territorios = {
                territoriosIds: this.idsTerritoriosSelecionados
            };

            TerritorioService.solicitacaoLaudo(territorios)
                .then(({ data }) => {
                    this.territorios = {};

                    for (let i = 0; i < data.length; i += 1) {
                        let id = data[i].id;

                        this.territorios[id] = data[i];
                        this.cardValido[id] = this.cardValido[id] || false;
                        this.dados[id] = this.dados[id] || {};
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message:
                            error?.message ||
                            this.$t('laudos.ocorreuUmErroAoBuscarTerritorios')
                    });
                });
        },

        removerTerritorio(id) {
            this.idsTerritoriosSelecionados.splice(
                this.idsTerritoriosSelecionados.indexOf(id),
                1
            );

            delete this.territorios[id];
            delete this.cardValido[id];
            delete this.dados[id];

            this.atualizarerritoriosSelecionados();
            this.validarFinalizacao();
        },

        changeShowModalAddTerritorios() {
            this.atualizarerritoriosSelecionados();
            this.showModalAddTerritorios = !this.showModalAddTerritorios;
        },

        setValidacao({ valido, id }) {
            this.cardValido[id] = valido;
            this.validarFinalizacao();
        },

        validarFinalizacao() {
            let finalizar = true;

            for (const id in this.cardValido) {
                if (this.cardValido[id] === false) {
                    finalizar = false;
                    break;
                }
            }

            this.finalizar = finalizar;
        },

        setDados({ dados, id }) {
            this.dados[id] = dados;
        },

        solicitarLaudos() {
            const informacaoLaudos = [];
            for (const id in this.cardValido) {
                if (
                    !this.dados[id].representantes.length &&
                    this.dados[id].clienteNovo === null
                ) {
                    this.$notify.warning(
                        'É necessário informar pelo menos 1 pessoa em cada território.'
                    );
                    return;
                }

                if (this.dados[id].representantes.length > 0) {
                    this.dados[id].representantes = this.dados[
                        id
                    ].representantes.map(rep => {
                        if (rep) {
                            return {
                                nomeRepresentante: rep.nomeRazaoSocial,
                                cpfCnpjRepresentante: rep.cpfCnpj,
                                tipoDocumentoRepresentante:
                                    rep.tipoDocumentoRepresentante
                            };
                        }
                    });
                }

                if (this.dados[id].clienteNovo !== null) {
                    this.dados[id].representantes.push(
                        this.dados[id].clienteNovo
                    );
                }
                delete this.dados[id].clienteNovo;
                informacaoLaudos.push(this.dados[id]);
            }

            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'laudos.solicitacaoRealizadaComSucesso'
                        )
                    });
                    this.$router.go(-1);
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.mensagem
                    });
                });
        },

        addTerritorios(territorios) {
            this.idsTerritoriosSelecionados = territorios.map(
                territorio => territorio.id
            );
            this.getTerritorios();
            this.changeShowModalAddTerritorios();
        },

        atualizarerritoriosSelecionados() {
            this.territoriosSelecionados = [];

            for (const id in this.territorios) {
                this.territoriosSelecionados.push(this.territorios[id]);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#solicitar-laudos {
    width: calc(100vw - 115px);
    margin: 15px auto;

    .territorios {
        header {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .sem-territorios {
            display: flex;
            align-items: center;
            justify-content: center;

            height: 400px;

            a {
                text-decoration: underline;
            }

            a:hover {
                cursor: pointer;
            }
        }
    }

    .acoes {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}
</style>
